import React, {useContext, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";

import {Breadcrumb, Button, Checkbox, Col, Form, Input, notification, Row, Select, Space, Spin,} from "antd";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
import DB_User from "../../../database/admin/user";
import DB_Branch from "../../../database/dictionary/branch";
import '../../../style/css/general.css';
import './edit-user.css';
import Avatar from "antd/es/avatar/avatar";
import axios from "axios";

import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Context} from "../../../App";
import DB_PatternActivity from "../../../database/dictionary/pattern-activity";
import {isNull} from "../../tech/check";
import BackButton from "../../tech/back_button";


export const EditUser = () => {
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();

    const {token, setToken} = useContext(Context);

    const {getBranches} = DB_Branch(token);
    const {getPatternActivities} = DB_PatternActivity(token);
    const {getRoles, getUser, checkEmail, statusUser, createUser, updateUser} = DB_User(token);

    const params = useLocation().state;
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [wait, setWait] = useState(true);
    const [isLoadSystem, setIsLoadSystem] = useState(true)

    const [patternActivities, setPatternActivities] = useState([])
    const [roles, setRoles] = useState([])

    const [isActive, setIsActive] = useState()

    const [passwordRequired, setPasswordRequired] = useState(true)

    // const [avatar, setAvatar] = useState()
    // const [avatarFile, setAvatarFile] = useState()

    const [branch, setBranch] = useState([])
    const [userInitials, setUserInitials] = useState()


    const StatusButton = () => {
        if (params.id == null) {
            return
        }
        if (isActive) {
            return (
                <Button type={"default"} danger onClick={changeStatusUser}>{t('deactivate')}</Button>
            )

        } else {
            return (
                <Button type={"default"} onClick={changeStatusUser}>{t('activate')}</Button>
            )
        }
    }

    const changeStatusUser = async () => {
        setWait(true)
        const formData = new FormData()
        formData.append('is_active', (isActive ? 0 : 1))
        formData.append('user_id', params.id)

        statusUser(formData)
            .then(res => {
                if (res.status === 200) {
                    setIsActive(!isActive);
                    setWait(false)
                } else {
                    setWait(false)
                    errorConnect();
                }
            })
            .catch((e) => {
                if (e.response.status === 403) {
                    window.location.reload()
                } else {
                    setWait(false);
                    errorConnect();
                }
            });
    }


    const openNotificationFalse = (action) => {
        notification.error({
            message: 'Failed',
            description:
                t('e_update_create', {action: action, type: t('user').toLowerCase()}),
            placement: 'top'
        });
    };

    // const getBase64 = (img, callback) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('load', () => callback(reader.result));
    //     reader.readAsDataURL(img);
    // };
    //
    // const handleChange = (info) => {
    //     setAvatarFile(info.file.originFileObj)
    //     if (info.file.status === 'done') {
    //         getBase64(info.file.originFileObj, url => {
    //             setAvatar(url);
    //         });
    //     }
    // };


    const setAutoPass = () => {
        const pass = autoPass()

        form.setFieldsValue({
            password: pass,
            confirmPassword: pass
        });
    }

    const autoPass = () => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < 8; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    const onFinish = async (values) => {
        setWait(true);

        const formDataEmail = new FormData()
        formDataEmail.append('email', values['email'])
        if (params.id != null) {
            formDataEmail.append('user_id', params.id)
        }


        if (await checkEmail(formDataEmail)) {
            const formData = new FormData()
            if (params.id != null) {
                formData.append('id', params.id)
            }

            formData.append('name', values['name'])
            formData.append('email', values['email'])
            formData.append('role', values['role'])
            formData.append('pattern', isNull(values['patternActivity']) ? [] : values['patternActivity'])
            formData.append('branch', isNull(values['branch_id']) ? [] : values['branch_id'])
            formData.append('edit_org_structure', (values['edit_org_structure'] ? 1 : 0))
            if (values['password'] != null) {
                formData.append('password', values['password'])
            }

            // if (avatarFile !== undefined) {
            //     formData.append('avatar', avatarFile)
            // }


            if (params.id == null) {
                createUser(formData)
                    .then(res => {
                        if (res.status === 200) {
                            navigate("site/admin/users", {replace: true});
                        } else {
                            openNotificationFalse(t('creating'));
                        }
                    })
                    .catch(e => {
                        if (e.response.status === 403) {
                            window.location.reload()
                        } else {
                            setWait(false);
                            errorConnect();
                        }
                    })

            } else {
                updateUser(formData)
                    .then(res => {
                        if (res.status === 200) {
                            navigate("/site/admin/users", {replace: true});
                        } else {
                            openNotificationFalse(t('updating'));
                        }
                    })
                    .catch(e => {
                        if (e.response.status === 403) {
                            window.location.reload()
                        } else {
                            setWait(false);
                            errorConnect();
                        }
                    })
            }
        } else {
            setWait(false);
            notification.error({
                message: 'Error',
                description:
                    t('e_duplicate_email', {email: values['email']}),
                placement: 'top'
            });
        }


    };


    const requiredPassword = (e) => {
        if (e.target.value.length > 0) {
            setPasswordRequired(true)
        } else {
            setPasswordRequired(false)
        }

    }


    useEffect(() => {
        window.scroll(0, 0)

        axios.all([getRoles(), getPatternActivities(), getBranches()])
            .then(axios.spread((roles, pattern, branch) => {
                setRoles(roles.data)
                setPatternActivities(pattern.data['data'])
                setBranch(branch.data['data'])

                setIsLoadSystem(false)
            })).catch((e) => {
            if (e.request.status === 403) {
                setToken(null)
            } else {
                setWait(false)
                errorConnect()
            }
        });
    }, [])


    useEffect(() => {
        if (!isLoadSystem) {
            if (params.id != null) {
                setPasswordRequired(false)
                getUser(params.id)
                    .then(res => {
                        res.data.map(user => {
                            if (user['name'] == null) {
                                navigate("site/admin/user", {replace: true});
                                //setAvatar('https://avatars.dicebear.com/api/adventurer-neutral/' + Math.random() + '.svg')
                            }
                            const initials = user['name'].split(" ")
                                .map((l, i) => {
                                    if (i < 3) {
                                        return l[0]
                                    }
                                })
                            setUserInitials(initials)
                            setIsActive(user['is_active']);
                            // if (user['avatar'] != null) {
                            //     setAvatar(user['avatar'])
                            // }

                            form.setFieldsValue({
                                name: user['name'],
                                email: user['email'],
                                role: user['role'],
                                patternActivity: user['pattern_activity'],
                                branch_id: user['branch'],
                                edit_org_structure: !!user['edit_org_structure']

                            });
                            setWait(false);
                        })
                    })
                    .catch((e) => {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    });
            } else {
                // setAvatar(avatar_url + Math.random() + '.png')
                setWait(false);
            }
        }
    }, [isLoadSystem])


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('user')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>

                <Row>
                    <Col flex={1}>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <Avatar
                                size={150}
                                style={{
                                    color: '#3c7586',
                                    backgroundColor: '#cee8e9',
                                }}>{userInitials}</Avatar>
                            <br/>
                            <br/>

                        </div>
                    </Col>
                    <Col flex={7}>
                        <Form form={form}
                              labelCol={{
                                  span: 8
                              }}
                              wrapperCol={{
                                  span: 10
                              }}
                              layout={"vertical"}
                              onFinish={onFinish}
                              autoComplete="off"
                              id={"form"}
                        >
                            <Form.Item style={{marginBottom: '10pt'}}
                                       name="name"
                                       label={t('name')}
                                       rules={[
                                           {
                                               required: true,
                                               message: t('e_input', {input: t('name').toLowerCase()}),
                                           },
                                       ]}
                                       hasFeedback
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                name={"email"}
                                label={t('email')}
                                tooltip={t('login')}
                                rules={[
                                    {
                                        type: 'email',
                                        message: t('e_valid_email'),
                                    },
                                    {
                                        required: true,
                                        message: t('e_input', {input: t('email').toLowerCase()}),
                                    },
                                ]}
                                hasFeedback
                                style={{marginBottom: '10pt'}}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                name={"password"}
                                label={t('password')}
                                rules={[
                                    {
                                        required: passwordRequired,
                                        message: t('e_input', {input: t('password').toLowerCase()}),
                                    },
                                    {
                                        type: "string",
                                        min: 6
                                    }

                                ]}
                                hasFeedback
                                style={{marginBottom: '10pt'}}
                            >
                                <Input.Password onChange={requiredPassword}
                                                iconRender={(visible) => (visible ? <EyeTwoTone/> :
                                                    <EyeInvisibleOutlined/>)}/>
                            </Form.Item>

                            <Form.Item
                                name={"confirmPassword"}
                                label={t('confirm_password')}
                                dependencies={['password']}
                                rules={[
                                    {
                                        required: passwordRequired,
                                        message: t('e_input', {input: t('confirm_password').toLowerCase()}),
                                    },
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }

                                            return Promise.reject(new Error(t('e_confirm_password')));
                                        },
                                    }),
                                ]}
                                hasFeedback
                                style={{marginBottom: '10pt'}}
                            >
                                <Input.Password onChange={requiredPassword}
                                                iconRender={(visible) => (visible ? <EyeTwoTone/> :
                                                    <EyeInvisibleOutlined/>)}/>
                            </Form.Item>

                            <Form.Item style={{marginBottom: '10pt'}}>
                                <Button type={"default"} onClick={setAutoPass}>{t('auto_generate_password')}</Button>
                            </Form.Item>


                            <Form.Item
                                name={"role"}
                                label={t('role')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('e_select', {select: t('role').toLowerCase()}),
                                    },
                                ]}
                                hasFeedback
                                style={{marginBottom: '10pt'}}
                            >
                                <Select>
                                    {roles.map(role =>
                                        <Select.Option key={role.id} value={role.id}>{t(role.name)}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name="branch_id"
                                label={t('branch')}
                                tooltip={t('branch_user')}
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: t('e_select', {select: t('branch').toLowerCase()}),
                                //     }
                                // ]}
                            >
                                <Select mode={"multiple"} allowClear>
                                    {branch.map(brnch =>
                                        <Select.Option key={brnch.id} value={brnch.id}>{brnch.name}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>

                            {/*<Form.Item*/}
                            {/*    name="branch"*/}
                            {/*    style={{marginBottom: '3pt'}}>*/}
                            {/*    <p>{t('org_structure')}</p>*/}
                            {/*</Form.Item>*/}

                            <Form.Item
                                name={"patternActivity"}
                                label={t('pattern_activity')}
                                tooltip={t('pattern_activity_user')}
                            >
                                <Select mode={"multiple"} allowClear>
                                    {patternActivities.map(pattern =>
                                        <Select.Option key={pattern.id} value={pattern.id}
                                                       disabled={pattern.status === 0}>{t(pattern.name)}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name={"edit_org_structure"}
                                valuePropName='checked'
                                noStyle
                                // label={t('edit-org-structure')}
                            >
                                <Checkbox>{t('edit_org_structure')}</Checkbox>
                            </Form.Item>
                        </Form>


                    </Col>
                </Row>
            </div>
            <Outlet/>
        </Spin>
    )
}

export default EditUser;